import React from 'react';
import { Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { GeneralAdviceFormItem } from '@components/Clinicians/Session/Components/GeneralAdviceFormItem';
import { SuggestedInvestigationsFormItem } from '@components/Clinicians/Session/Components/SuggestedInvestigationsFormItem';
import useAppointmentMeta from '@components/Clinicians/Session/hooks/useAppointmentMeta';
import { MedicationsFormItem } from './MedicationsFormItem';

export const RecommendationsFormItem = () => {
  const { t } = useTranslation('common');

  const { data: appointmentsMeta } = useAppointmentMeta();

  if (!appointmentsMeta?.appt_meds) return null;

  if (appointmentsMeta?.appt_version === 1) {
    return (
      <Card size="small" title={t('Recommendations')} style={{ marginBottom: 16 }} type="inner">
        <GeneralAdviceFormItem />
        <SuggestedInvestigationsFormItem />
        <MedicationsFormItem />
      </Card>
    );
  }

  return (
    <>
      <GeneralAdviceFormItem />
      <MedicationsFormItem />
    </>
  );
};
